import React, { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import profilePhoto from "../../assets/images/about-me.png";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Close mobile menu on route change
  useEffect(() => {
    setMenuOpen(false);
    window.scrollTo(0, 0);
  }, [location.pathname]);

  // Prevent body scroll when mobile menu is open
  useEffect(() => {
    if (menuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [menuOpen]);

  const navLinks = [
    { label: "About", to: "/#hero" },
    { label: "Services", to: "/#services" },
    { label: "My Work", to: "/#products" },
    { label: "Case Studies", to: "/#case-studies" },
    { label: "Blog", to: "/#blogs" },
  ];

  const handleNavClick = (link) => {
    setMenuOpen(false);

    // If it's a hash link on the home page
    if (link.to.startsWith("/#")) {
      const hash = link.to.substring(1);
      if (location.pathname === "/") {
        const el = document.querySelector(hash);
        if (el) el.scrollIntoView({ behavior: "smooth" });
      }
    }
  };

  return (
    <header className={`header${scrolled ? " scrolled" : ""}`} id="site-header">
      <div className="container">
        <div className="header__inner">
          <div className="header__column header__column--left">
            <Link to="/" className="header__brand">
              <img src={profilePhoto} alt="Ashish Subedi" className="header__logo" />
            </Link>
          </div>

          <ul className={`header__nav-links${menuOpen ? " mobile-open" : ""}`}>
            {/* Mobile Close Button */}
            <li className="header__nav-item--mobile-only header__close-container">
              <button 
                className="header__close-btn" 
                onClick={() => setMenuOpen(false)}
                aria-label="Close menu"
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              </button>
            </li>

            {navLinks.map((link) => (
              <li key={link.label}>
                {link.to.startsWith("/#") ? (
                  <Link
                    className={`header__nav-link`}
                    to={link.to}
                    onClick={() => handleNavClick(link)}
                  >
                    {link.label}
                  </Link>
                ) : (
                  <NavLink
                    className={({ isActive }) =>
                      `header__nav-link${isActive ? " header__nav-link--active" : ""}`
                    }
                    to={link.to}
                    onClick={() => handleNavClick(link)}
                  >
                    {link.label}
                  </NavLink>
                )}
              </li>
            ))}
          </ul>

          <div className="header__column header__column--right">
            <a 
              href="https://calendly.com/connect-with-ashish-subedi" 
              className="header__cta header__cta--dark" 
              id="header-cta"
              target="_blank"
              rel="noopener noreferrer"
            >
              Hop on a call
            </a>

            <button
              className={`header__menu-toggle${menuOpen ? " active" : ""}`}
              onClick={() => setMenuOpen(!menuOpen)}
              aria-label="Toggle navigation menu"
              id="menu-toggle"
            >
              <span></span>
              <span></span>
              <span></span>
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Navigation Backdrop */}
      <div 
        className={`header__nav-backdrop${menuOpen ? " active" : ""}`} 
        onClick={() => setMenuOpen(false)}
        aria-hidden="true"
      />
    </header>
  );
};

export default Header;
